<template>
    <el-card>
        <template #header>
            <content-header> 支付配置管理 </content-header>
        </template>

        <div class="header-button">
            <search-form ref="searchForm" :fields="search" />
            <div class="selections">
                <button-link :to="link" type="success">
                    <slot>添加新配置</slot>
                </button-link>
            </div>
        </div>

        <el-table :data="users" resource="pay-merchant">
            <el-table-column
                align="center"
                label="ID"
                min-width="2%"
                prop="id"
                show-overflow-tooltip
            />
            <el-table-column
                align="center"
                label="名称"
                min-width="8%"
                prop="name"
                show-overflow-tooltip
            />
            <el-table-column
                align="center"
                label="支付类型"
                min-width="5%"
                prop="type_name"
                show-overflow-tooltip
            />
            <el-table-column
                align="center"
                label="区域"
                min-width="6%"
                prop="area.name"
                show-overflow-tooltip
            />
            <el-table-column
                align="center"
                label="状态"
                min-width="4%"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status" type="success">正常</el-tag>
                    <el-tag v-else type="danger">禁用</el-tag>
                </template>
            </el-table-column>

            <!-- <el-table-column
                align="center"
                label="配置信息"
                min-width="5%"
                prop="id"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <router-link type="primary" v-bind:to="'/admin_merchant_config/get?id=' + scope.row.id">配置信息
                    </router-link>
                </template>
            </el-table-column> -->

            <el-table-column
                align="center"
                label="添加时间"
                min-width="5%"
                prop="created_at"
                show-overflow-tooltip
            />

            <el-table-column
                align="center"
                label="操作"
                show-overflow-tooltip
                width="150"
            >
                <template #default="{ row, $index }">
                    <!-- <button @click="doEdit(row.id)">编辑1</button> -->
                    <!-- <button-link
                        size="small"
                        :to="'/pay_merchants/create/?id=' + row.id"
                    >
                        <slot>编辑{{ row.id }}</slot>
                    -->
                    <!-- <button-link /> -->
                    <button-link
                        size="small"
                        :to="`/pay_merchants/${row.id}/edit`"
                        >编辑</button-link
                    >
                    <row-destroy />
                </template>
            </el-table-column>
        </el-table>
        <div class="card-footer">
            <pagination :page="page" />
        </div>
    </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getPays } from "@/api/pay-merchant";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import ButtonLink from "@c/ButtonLink";
import { mixinsAutoPageSize } from "@/libs/utils";

export default {
    name: "Index",
    components: {
        RowToEdit,
        RowDestroy,
        SearchForm,
        Pagination,
        ButtonLink,
    },
    data() {
        return {
            search: [
                {
                    field: "name",
                    label: "名称",
                },
                {
                    field: "phone",
                    label: "手机号",
                },
            ],
            users: [],
            page: null,
            first_blood: true,
        };
    },

    mixins: [mixinsAutoPageSize],
    created() {},
    computed: {
        link() {
            return `/pay_merchants/create`;
        },
    },
    watch: {
        $route: {
            async handler(newVal) {
                await this.autoPageSize(53, newVal);
                const {
                    data: { data, meta },
                } = await getPays(newVal.query);
                this.users = data;
                this.page = meta;
            },
            immediate: true,
        },
    },
    // methods: {
    //     doEdit(row) {
    //         this.$router.push({
    //             path: "/pay_merchants/create/?id=",
    //             query: {
    //                 id: row.id,
    //             },
    //         });
    //     },
    // },
};
</script>
<style lang="scss">
.header-button {
    display: flex;
    justify-content: space-between;

    .selections {
        display: inline-block;
        margin-right: 10px;
    }
}
</style>
